
import _ from 'lodash';

class Swipper {

  constructor(callback, containerSize) {
    this.onTouchStart = this.onTouchStart.bind(this);
    this.onTouchMove = this.onTouchMove.bind(this);
    this.onTouchEnd = this.onTouchEnd.bind(this);
    this.onTransitionEnd = this.onTransitionEnd.bind(this);

    this.setContainerSize(containerSize);
    this.initElements();
    this.initEvents();
    this.initDefaults();

    this.swipeCallback = _.isFunction(callback) ? callback : _.noop;
  }

  initElements() {
    this.wrap = $('.swipe-wrap');
    this.container = $('#slider');
    this.slides = $('.slide');
    this.current = $('.swipe-current');
    this.currentItem = $('.current-slide .fullscreen-item').last();
    this.nextItem = $('.next-slide .fullscreen-item');
    this.prevItem = $('.prev-slide .fullscreen-item');

    this.isLastSlide = this.nextItem.length == 0;
    this.isFirstSlide = this.prevItem.length == 0;

    this.direction = 0;
  }

  initEvents() {
    this.wrap[0] && this.wrap[0].addEventListener('touchstart', this.onTouchStart, false);
  }

  initDefaults() {

    this.scale = 1;

    this.pos = {
      x: 0,
      y: 0
    };

    this.pinchStart = {
      dist: 0,
      x: 0,
      y: 0
    };

    this.hiResShown = true;
    this.nonCurrentShown = true;
  }

  turnTransitionOff() {
    if (this.transitionOn) {
      this.wrap.addClass('touching');
      this.transitionOn = false;
    }
  }

  turnTransitionOn() {
    if (!this.transitionOn) {
      this.wrap.removeClass('touching');
      this.transitionOn = true;
    }
  }

  hideHiResImages() {
    if (this.hiResShown) {
      this.wrap.addClass('moving');
      this.hiResShown = false;
    }
  }

  showHiResImages() {
    if (!this.hiResShown) {
      this.wrap.removeClass('moving');
      this.hiResShown = true;
    }
  }

  hideNonCurrentImages() {
    if (this.nonCurrentShown) {
      this.wrap.addClass('pinching');
      this.nonCurrentShown = false;
    }
  }

  showNonCurrentImages() {
    if (!this.nonCurrentShown) {
      this.wrap.removeClass('pinching');
      this.nonCurrentShown = true;
    }
  }

  onTouchStart(event) {
    this.startTouch = $.extend(true, {}, event); //the event object can change on some devices
    const touches = event.touches;

    this.turnTransitionOff();
    this.initElements();

    this.direction = 0;

    if (touches.length == 2) {
      this.handleStartPinching(event.touches);
    } else {
      var touch = event.touches[0];
      if (this.scale > 1) {
        this.handleStartDragging(touch);
      } else {
        this.handleStartSwiping(touch);
      }
    }

    this.wrap[0] && this.wrap[0].addEventListener('touchmove', this.onTouchMove, false);
    this.wrap[0] && this.wrap[0].addEventListener('touchend', this.onTouchEnd, false);
  }

  isDoubleTap(tapTime, lastTapTime) {
    return tapTime - lastTapTime < 300;
  }

  handleStartSwiping(touch) {
    this.hideHiResImages();
    this.showNonCurrentImages();

    //on movement start - the slider is at 0
    this.pos = {
      x: 0,
      y: 0
    };

    // get initial touch coords
    this.touchStart = {
      x: touch.screenX,
      y: touch.screenY,
    };
  }

  calcBounds(){
    //moving scaled image - set boundaries

    var rect = this.currentItem[0].getBoundingClientRect();

    var cur_w = rect.width;
    var cur_h = rect.height;

    var max_x = Math.abs(cur_w - this.containerSize.width) / 2;
    var max_y = Math.abs(cur_h - this.containerSize.height) / 2;

    this.bounds = {
      max_x,
      max_y,
      min_x: (-1) * max_x,
      min_y: (-1) * max_y
    };

    console.log("calculated bounds", this.bounds);
  }

  handleStartDragging(touch) {
    this.showHiResImages();
    this.hideNonCurrentImages();

    this.calcBounds();

    this.pinchStart = {
      dist: 0,
      x: touch.screenX,
      y: touch.screenY,
    };

    // get initial touch coords
    this.touchStart = {
      x: touch.screenX - this.pos.x,
      y: touch.screenY - this.pos.y,
    };
  }

  handleStartPinching(touches) {
    this.showHiResImages();
    this.hideNonCurrentImages();

    this.calcBounds();

    var rect = this.currentItem[0].getBoundingClientRect();

    var touch1clientX = touches[0].clientX;
    var touch1clientY = touches[0].clientY;
    var touch2clientX = touches[1].clientX;
    var touch2clientY = touches[1].clientY;

    var touchesX = (touch1clientX + touch2clientX) / 2;
    var touchesY = (touch1clientY + touch2clientY) / 2;

    var imageOffsetX = rect.left;
    var imageOffsetY = rect.top;
    var imageWidth = rect.width;
    var imageHeight = rect.height;

    //relative touch position in the image
    var touchX = ((touchesX - imageOffsetX) / imageWidth - 0.5) * imageWidth / this.scale;
    var touchY = ((touchesY - imageOffsetY) / imageHeight - 0.5) * imageHeight / this.scale;

    this.pinchStart = {
      dist: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.scale,
      x: ((touches[0].screenX + touches[1].screenX) / 2) - (this.pos.x || 0),
      y: ((touches[0].screenY + touches[1].screenY) / 2) - (this.pos.y || 0),
      touchX,
      touchY,
      touchScale: this.scale
    }
  }

  onTouchMove(event) {

    event.preventDefault(); //DISABLE SCROLL

    const touches = event.touches;

    if (touches.length == 2) {
      this.handlePinching(touches);
    }
    else if (touches.length == 1) {
      if (this.scale > 1) {
        this.handleDragging(touches);
      }
      else {
        let touch = touches[0];
        this.handleSwipeDragging(touch);
      }
    }
    this.move();
  }

  handleSwipeDragging(touch) {
    // console.log('Got touch events', touches.screenX, touches.screenY);
    var delta = {
      x: touch.screenX - this.touchStart.x,
      y: touch.screenY - this.touchStart.y
    };

    // console.log('Measured Delta', delta);

    // increase resistance if first or last slide
    if (this.isDraggingOutOfBounds(delta.x)) {
      delta.x /= Math.abs(delta.x) / this.containerSize.width + 1; // determine resistance level
    }

    //set the new slides position
    this.pos = {
      x: delta.x,
      y: this.pos.y //on regular swipe - do not change y position
    };
  }

  isDraggingOutOfBounds(dirction) {
    return (this.isLastSlide && dirction < 0) ||  // if last slide and sliding right
      (this.isFirstSlide && dirction > 0);        // if first slide and sliding left;
  }

  handleDragging(touches) {
    var deltaPinch = {
      x: (touches[0].screenX) - this.touchStart.x,
      y: (touches[0].screenY) - this.touchStart.y
    };


    var x = deltaPinch.x;
    if (this.bounds.min_x > x && this.bounds.min_x - x < 100) { //do not limit the drag - but snap within 150px
      x = this.bounds.min_x;
    }
    if (this.bounds.max_x < x && x - this.bounds.max_x < 100) {
      x = this.bounds.max_x;
    }

    var y = deltaPinch.y;
    if (this.bounds.min_y > y && this.bounds.min_y - y < 100) { //(500 > 10
      y = this.bounds.min_y;
    }
    if (this.bounds.max_y < y && y - this.bounds.max_y < 100) {
      y = this.bounds.max_y;
    }

    this.pos = {x, y};

    // this.pos = {
    //   x: Math.min(Math.max(this.bounds.min_x, deltaPinch.x), this.bounds.max_x),
    //   y: Math.min(Math.max(this.bounds.min_y, deltaPinch.y), this.bounds.max_y)
    // };
  }

  handlePinching(touches) {
    var deltaPinch = {
      scale: Math.sqrt(Math.pow(touches[0].screenX - touches[1].screenX, 2) + Math.pow(touches[0].screenY - touches[1].screenY, 2)) / this.pinchStart.dist,
      x: ((touches[0].screenX + touches[1].screenX) / 2) - this.pinchStart.x,
      y: ((touches[0].screenY + touches[1].screenY) / 2) - this.pinchStart.y
    };

    var newScale = Math.max(1, deltaPinch.scale);

    var pinchPositionFix = {
      x: ((newScale - this.pinchStart.touchScale) * this.pinchStart.touchX),
      y: ((newScale - this.pinchStart.touchScale) * this.pinchStart.touchY),
    };

    this.pos = {
      x: deltaPinch.x - pinchPositionFix.x,
      y: deltaPinch.y - pinchPositionFix.y
    };

    this.scale = newScale;
  }

  isTap(startTouchEvent, endTouchEvent) {
    if (startTouchEvent.touches.length === 1 &&
      endTouchEvent.touches.length === 0 &&
      endTouchEvent.timeStamp - startTouchEvent.timeStamp < 250) {
      const startTouch = startTouchEvent.touches[0];
      const endTouch = endTouchEvent.changedTouches[0];
      const distanceX = Math.abs(startTouch.screenX - endTouch.screenX);
      const distanceY = Math.abs(startTouch.screenY - endTouch.screenY);
      return distanceX < 10 && distanceY < 10;
    }
    return false;
  }

  onTouchEnd(event) {

    this.turnTransitionOn();
    const endTouchTime = event.timeStamp;
    if (this.isTap(this.startTouch, event)) {
      if (this.isDoubleTap(endTouchTime, this.lastTapTime)) {
        this.handleDoubleTap();
      }
      this.lastTapTime = endTouchTime;
    }
    if (this.scale > 1) {
      this.hideNonCurrentImages();
      if (this.scale > 2) {

        //bounce back to max scale of x2

        //this.scale = 2; - removed because the just between scale > 2 to scale = 2 was annoying
      }
    } else {

      //regular release - animate slides
      const currentX = this.pos.x;
      const distance = Math.abs(currentX);
      const duration = endTouchTime - this.startTouch.timeStamp;

      if (this.isSwipe(distance, duration) && !this.isDraggingOutOfBounds(currentX)) {
        // determine direction of swipe
        this.direction = Math.sign(currentX);
        //set the new position of the slider
        this.pos.x = this.direction * this.containerSize.width;
      } else {
        this.pos.x = 0;
        this.direction = 0;
      }
      this.pos.y = 0;

      if ((currentX - this.pos.x) == 0) {
        //if there is not transition going to happen, trigger transitionEnd event manually
        this.onTransitionEnd();
      } else {
        //otherwise - register to event end
        var element = this.wrap[0];
        if (element) {
          element.addEventListener('webkitTransitionEnd', this.onTransitionEnd, false);
          element.addEventListener('msTransitionEnd', this.onTransitionEnd, false);
          element.addEventListener('oTransitionEnd', this.onTransitionEnd, false);
          element.addEventListener('otransitionend', this.onTransitionEnd, false);
          element.addEventListener('transitionend', this.onTransitionEnd, false);
        }
      }

    }
    this.showHiResImages();
    this.move();

    this.wrap[0] && this.wrap[0].removeEventListener('touchmove', this.onTouchMove, false);
    this.wrap[0] && this.wrap[0].removeEventListener('touchend', this.onTouchEnd, false);
  }

  isSwipe(distance, duration) {
    const velocity = distance / duration;
    // determine if slide attempt triggers next/prev slide
    return (distance > 10 && velocity > 0.5)        // quick swipe
      || (distance > this.containerSize.width / 2); // large distance
  }

  onTransitionEnd() {
    this.pos = {x: 0, y: 0};
    this.showHiResImages();
    this.showNonCurrentImages();
    this.swipeCallback((-1) * this.direction);

    var element = this.wrap[0];
    if (element) {
      element.removeEventListener('webkitTransitionEnd', this.onTransitionEnd, false);
      element.removeEventListener('msTransitionEnd', this.onTransitionEnd, false);
      element.removeEventListener('oTransitionEnd', this.onTransitionEnd, false);
      element.removeEventListener('otransitionend', this.onTransitionEnd, false);
      element.removeEventListener('transitionend', this.onTransitionEnd, false);
    }
  }

  handleDoubleTap() {
    if (this.scale > 1) {
      this.scale = 1;
      this.showNonCurrentImages();
    } else {
      this.scale = 2;
      this.hideNonCurrentImages();
    }

    this.pos = {
      x: 0,
      y: 0
    };

    this.turnTransitionOn();
    this.showHiResImages();
    this.move();
  }

  move() {
    const val = `translate3d(${this.pos.x}px ,${this.pos.y}px ,0) scale(${this.scale})`;

    this.wrap.css({
      'transform': val,
      '-o-transform': val,
      '-ms-transform': val,
      '-webkit-transform': val
    }).removeClass('before-swipe');
  }

  setContainerSize({width, height}) {
    this.containerSize = {width, height};
  }
}

export default Swipper



// WEBPACK FOOTER //
// ./components/fullscreen/swipper.js